import Player from '@vimeo/player';

const videoReferences = document.querySelectorAll('.js-lightbox-video[data-videoid]'),
    videosContainer = document.querySelector('.js-videos-container'),
    videosWrapper = document.querySelector('.js-videos-wrapper'),
    aspectRatio = 9 / 16;

let videosReady = 0,
    videoArray = [];

export function init () {
    // Get all the videos ready
    load();

    // Pause/Close/Hide video events
    videosContainer.addEventListener('click', closeVideos);

    window.addEventListener('keydown', e => {
        var keyCode = e.keyCode;

        // If this is escape or enter, close the video
        if (keyCode === 27 || keyCode === 13) {
            closeVideos();
        }
    });

    // Remove some iframe styles when going to fullscreen
    // to fix an iOS bug with video positioning
    document.addEventListener('webkitfullscreenchange', e => {
        if (document.webkitFullscreenElement) {
            // Remove transform classes
            videosContainer.querySelectorAll('iframe').forEach(iframe => {
                iframe.style.setProperty('--tw-translate-x', 0);
                iframe.style.setProperty('--tw-translate-y', 0);
            });
        } else {
            // Add transform classes
            videosContainer.querySelectorAll('iframe').forEach(iframe => {
                iframe.style.setProperty('--tw-translate-x', '-50%');
                iframe.style.setProperty('--tw-translate-y', '-50%');
            });
        }
    });
}

function load() {
    let t;

    [...videoReferences].forEach((el, i) => {
        let videoId = (el.dataset.videoid) ? el.dataset.videoid : i.toString(),
            video = document.createElement('div'),
            youtubePlayer,
            vimeoPlayer;
        
        //  Add unique ID to this video element
        video.id = "video_" + videoId;

        // Save video DOM element to global videos container
        videosWrapper.appendChild(video);

        if (!isNaN(parseFloat(videoId)) && isFinite(videoId)) {
            vimeoPlayer = new Player(video, {
                width: 1920,
                id: videoId,
                playsinline: true,
                // responsive: true
            });

            vimeoPlayer.ready().then(videoPlayerReady(el));
        } else {
            // YouTube player
            youtubePlayer = new YT.Player(video, {
                width: '1920',
                height: '1080',
                videoId: videoId,
                playerVars: {
                    fs: 0,
                    modestbranding: 1,
                    showinfo: 0,
                },
                events: {
                    'onReady': youtubePlayerReady
                }
            });
        }

        videoArray.push({
            videoId: videoId,
            vimeoPlayer: vimeoPlayer,
            youtubePlayer: youtubePlayer
        });
    });

    // When there all the videos are 'ready' force hide the container again
    t = setInterval(function () {
        if (videosReady === videoReferences.length) {
            clearInterval(t);

            videosContainer.classList.add('all-videos-ready');
        }
    }, 25);
}

function youtubePlayerReady (event) {
    videoPlayerReady(event.target.getIframe());
}

function videoPlayerReady(el) {
    // Add click listener to this play link
    el.addEventListener('click', playVideo);

    // Add video-ready class to this play link
    el.classList.add('video-ready');

    videosReady++;
}

// Show overlay and play video
function playVideo(e) {
    e.preventDefault();

    let videoObj = videoArray.filter(obj => {
            return obj.videoId == this.dataset.videoid;
        }),
        video = document.getElementById('video_' + this.dataset.videoid);
    
    // Make sure all videos are hidden to start with
    let videoIframes = videosWrapper.querySelectorAll('iframe');

    [...videoIframes].forEach(el => {
        el.style.display = 'none';
    });

    // Show and fadeIn video container
    videosContainer.classList.add('opacity-100');
    videosContainer.classList.remove('pointer-events-none');

    // If a Vimeo instance we can play the video immediately
    if (typeof videoObj[0].vimeoPlayer !== 'undefined') {
        video = video.querySelector('iframe');
    }

    video.style.display = 'block';

    let videoStyles = window.getComputedStyle(video, null),
        videoWidth = parseInt(videoStyles.getPropertyValue('width'), 10);

    video.height = videoWidth * aspectRatio;

    if (typeof videoObj[0].vimeoPlayer !== 'undefined') {
        videoObj[0].vimeoPlayer.play();
    } else if (typeof videoObj[0].youtubePlayer !== 'undefined') {
        videoObj[0].youtubePlayer.playVideo();
    }
}

// Pause videos and hide page overlay
function closeVideos() {
    var i = 0;

    // Pause every video just in case
    for (i; i < videoArray.length; i++) {
        if (typeof videoArray[i].vimeoPlayer !== 'undefined') {
            videoArray[i].vimeoPlayer.pause();
        } else if (typeof videoArray[i].youtubePlayer !== 'undefined') {
            videoArray[i].youtubePlayer.pauseVideo();
        } else {
            // As a last ditch attempt let's try and force a pause command through
            videoArray[i].otherPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    }

    // Fadeout overlay
    videosContainer.classList.remove('opacity-100');
    videosContainer.classList.add('pointer-events-none');
}